<script setup lang="ts">
type Props = {
  color: string
}

defineProps<Props>()
</script>

<template>
  <div
    class="shrink-0 rounded-sm"
    style="height: 0.875rem; width: 0.875rem"
    :style="{ backgroundColor: color }"
  />
</template>
